import ModelState from 'spa/state/_util/model';

class WorkersLanguageState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/workers'; }
  get subUrl() { return 'languages'; }
  get singular() { return 'languages'; }
  get plural() { return 'languages'; }

  getSingleRequest(model) {
    if (!this.url) {
      throw new Error('Missing option `url`');
    }
    if (!this.subUrl) {
      throw new Error('Missing option `subUrl`');
    }
    if (!this.singular) {
      throw new Error('Missing option `singular`');
    }
    return this.ctx.sdk.get(`${this.url}/${model.id}/${this.subUrl}`);
  }
}

export default WorkersLanguageState;



// WEBPACK FOOTER //
// ./spa/state/worker-languages.jsx